export default __webpack_public_path__ + "static/media/xio-logo.4f25c5ab.svg";